module.exports = __webpack_public_path__ + "static/assets/48b48339a84fc360f393a5b79f355e67.png";